import { combineReducers } from "redux";

import ProductCrossReferenceReducer from "@tIntermatic/Store/Data/ProductCrossReference/ProductCrossReferenceReducer";
import ProductCrossReferenceLookupReducer from "@tIntermatic/Store/Data/ProductCrossReferenceLookup/ProductCrossReferenceLookupReducer";

const dataReducers = {
    matchingIntermaticProducts: ProductCrossReferenceReducer,
    crossReferenceLookupList: ProductCrossReferenceLookupReducer,
};

export type DataReducers = typeof dataReducers;

const dataReducer = combineReducers(dataReducers as any);

export default dataReducer;
